import { Link, Head } from '@inertiajs/react'
import { ArrowRight } from 'lucide-react'
import { Button } from '@/components/ui/button'
import Layout from '@/components/Layout'
import type { ReactNode } from 'react'

export default function Subscribed({ noindex }: { noindex: boolean }) {
  return (
    <>
      <Head title="You're confirmed">
        {noindex && <meta head-key="robots" name="robots" content="noindex" />}
      </Head>

      <section className="relative overflow-hidden">
        <div className="pointer-events-none absolute inset-0 z-0" aria-hidden="true">
          <div className="absolute inset-x-0 top-0 h-[140%] bg-[linear-gradient(to_bottom,oklch(0.85_0.11_62/0.55)_0%,oklch(0.91_0.07_72/0.28)_28%,transparent_62%)]" />
          <div className="absolute -top-1/4 -right-[8%] h-[95%] w-[60%] rounded-full bg-[radial-gradient(circle,oklch(0.80_0.15_55/0.45)_0%,transparent_65%)] blur-2xl" />
        </div>
        <div className="relative z-10 mx-auto flex max-w-2xl flex-col items-center px-4 py-20 text-center sm:px-6 lg:py-28">
          <p className="flex items-center gap-2 text-sm font-semibold uppercase tracking-wide text-primary">
            <span aria-hidden="true">✦</span>
            Gala Season newsletter
          </p>
          <h1 className="mt-5 text-4xl font-semibold tracking-tight text-balance sm:text-5xl lg:text-6xl">
            You&apos;re on{' '}
            <span className="font-serif italic text-primary underline decoration-primary/30 decoration-4 underline-offset-4">
              the list
            </span>
            .
          </h1>
          <p className="mt-6 max-w-[48ch] text-lg text-foreground text-pretty">
            Once a month you&apos;ll get the galas, benefits, and charitable events worth knowing about, plus playbooks
            and reports from Run of Show.
          </p>
          <div className="mt-9 flex flex-wrap justify-center gap-4">
            <Button size="lg" asChild>
              <Link href="/events" className="gap-1.5">
                Discover upcoming events <ArrowRight className="size-4" />
              </Link>
            </Button>
            <Button size="lg" variant="outline" asChild>
              <Link href="/blog">Read Run of Show</Link>
            </Button>
          </div>
          <p className="mt-8 text-sm text-muted-foreground">
            Didn&apos;t mean to subscribe? Every email has a one-click unsubscribe link.
          </p>
        </div>
      </section>
    </>
  )
}

Subscribed.layout = (page: ReactNode) => <Layout hideNewsletterSignup>{page}</Layout>
